import { ordersV2API } from '~/services/api';
import { stringifyUrlSearchParams } from '~/utils/url';

import { type OrderItemResponse } from '../types/orderItem.type';
import {
  type GetOrderParameters,
  type OrderV2,
  type OrdersV2APIParameters,
  type OrdersV2Response,
  type PatchOrderItem,
  type PatchOrdersResponse,
} from '../types/ordersV2.type';

export const fetchOrderV2 = async (orderObjectId: string, parameters: GetOrderParameters = {}) => {
  const response = await ordersV2API.request<OrderV2>({
    params: parameters,
    url: `/v2/orders/${orderObjectId}`,
  });

  return response.data;
};

export const fetchOrdersV2 = async (parameters: OrdersV2APIParameters) => {
  const response = await ordersV2API.request<OrdersV2Response>({
    params: parameters,
    paramsSerializer: (params) => stringifyUrlSearchParams(params, { arrayFormat: 'repeat' }),
    url: `/v2/orders`,
  });
  return response.data;
};

export const fetchOrderItemsV2 = async (query: string, page: number, limit = 10) => {
  const response = await ordersV2API.request<OrderItemResponse>({
    method: 'GET',
    params: {
      limit,
      offset: limit * page,
      q: query,
    },
    url: '/v2/orders/items',
  });

  return response.data;
};

export const cloneOrderV2 = async (orderObjectId: string) => {
  const response = await ordersV2API.request<OrderV2>({
    method: 'POST',
    url: `/v2/orders/${orderObjectId}/clone`,
  });

  return response.data;
};

export const splitOrderV2 = async (
  orderObjectId: string,
  shipments: { line_item: string; quantity: number }[][],
) => {
  const response = await ordersV2API.request<OrderV2>({
    data: { shipments },
    method: 'POST',
    url: `/v2/orders/${orderObjectId}/split`,
  });

  return response.data;
};

export const patchOrdersV2 = async (orders: PatchOrderItem[]) => {
  const response = await ordersV2API.request<PatchOrdersResponse>({
    data: { orders },
    method: 'PATCH',
    url: '/v2/orders',
  });

  return response.data;
};
